function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.77 13.209L14.768 25.402a6.463 6.463 0 01-9.242 0c-2.552-2.593-2.552-6.796 0-9.388L17.53 3.82a3.878 3.878 0 015.545 0 4.028 4.028 0 010 5.634L11.06 21.647c-.511.519-1.34.519-1.85 0a1.343 1.343 0 010-1.878L20.297 8.518c.51-.518.511-1.358.001-1.877a1.292 1.292 0 00-1.847 0L7.363 17.89a4.027 4.027 0 000 5.633 3.876 3.876 0 005.542 0L24.921 11.33c2.552-2.593 2.552-6.795 0-9.387a6.461 6.461 0 00-9.24 0L3.68 14.137c-3.572 3.63-3.572 9.513 0 13.141a9.046 9.046 0 0012.936 0l12.003-12.193c.51-.518.51-1.358 0-1.876a1.292 1.292 0 00-1.848 0z",
  fill: "currentColor"
})));